var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5393 4.40048C25.9048 -1.29692 16.577 -1.584 10.6266 4.25447C4.79634 9.97485 4.82178 18.9791 9.954 24.7091C11.5005 26.4357 12.3522 28.6281 12.3522 30.8824V33.5589C12.3522 35.1307 13.3937 36.4636 14.8228 36.9041V38.3354C14.8228 40.356 16.2487 42 18.0016 42H23.9969C25.7497 42 27.1757 40.356 27.1757 38.3354V36.9041C28.6047 36.4635 29.6463 35.1307 29.6463 33.5589V30.8824C29.6463 28.6281 30.4981 26.4357 32.0447 24.709C37.2009 18.9518 37.1263 10.0499 31.5393 4.40048ZM23.9968 39.5295H18.0015C17.674 39.5295 17.2933 39.0079 17.2933 38.3354V37.0589H24.705V38.3354C24.7051 39.0079 24.3244 39.5295 23.9968 39.5295ZM27.1757 33.5589C27.1757 34.1266 26.7139 34.5883 26.1462 34.5883H15.8522C15.2845 34.5883 14.8228 34.1266 14.8228 33.5589V32.1177H27.1757V33.5589ZM30.2042 23.0606C28.5337 24.9257 27.5057 27.228 27.2433 29.6471H14.7552C14.4926 27.2281 13.4649 24.9258 11.7943 23.0607C9.74227 20.7697 8.62441 17.8118 8.64665 14.7319C8.69573 7.96067 14.2756 2.39355 21.1481 2.47154C27.8775 2.55076 33.3521 8.09185 33.3521 14.8235C33.3521 17.8689 32.2342 20.7943 30.2042 23.0606Z",
    fill: "#6A6A6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.8625ef561b473ae20bdc13c001580a83.svg";
export { ForwardRef as ReactComponent };